import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SessionSharedDataService } from 'src/app/services/session-shared-data.service';
import { FLAGS, FlagsService } from 'src/app/services/flags.service';
import { UiService } from 'src/app/services/ui.service';
import { PictureInPictureService } from './picture-in-picture.service';

@Injectable()
export class VideoCallControlsService {
  constructor(
    private sessionSharedDataService: SessionSharedDataService,
    private pictureInPictureService: PictureInPictureService,
    private uiService: UiService,
    private flagsService: FlagsService,
  ) {}

  showNewVctRightControls$ = combineLatest([
    this.sessionSharedDataService.isAppInWhiteboardView$.pipe(distinctUntilChanged()),
    this.uiService.isMobile.pipe(distinctUntilChanged()),
    this.pictureInPictureService.isPIPActive$.pipe(distinctUntilChanged()),
  ]).pipe(
    map(
      ([whiteboardView, isMobile, isPIPActive]) =>
        whiteboardView &&
        !isMobile &&
        !isPIPActive &&
        this.flagsService.isFlagEnabled(FLAGS.ENABLE_RIGHT_VIEW_NEW_VIDEO_CONTROLS),
    ),
    distinctUntilChanged(),
  );

  // -12 is appearing for Gallery view bottom bar controls
  tooltipOffsetY$ = this.showNewVctRightControls$.pipe(
    map((showVctRightControls) => (showVctRightControls ? 0 : -12)),
  );
}
